import { Outlet } from 'react-router-dom'

import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ProjectsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { LoadingState } from 'modules/project_management/components/LoadingState'
import { OnboardingContextProvider } from 'modules/project_management/contexts/onboardingContext'
import CollectionsBootstrap from 'modules/project_management/lib/CollectionsBootstrap'

const Container = () => {
  const { company } = useCurrentSession()
  const { loading: loadingPage, data: page } = useQuery(ProjectsRootPageDocument, {
    variables: {
      companyId: company.id,
      featureIds: [
        Features.projects_costs,
        Features.projects_clients,
        Features.projects_budget,
        Features.projects_overview,
      ],
      moduleId: AvailableModules.expenses,
    },
  })

  if (loadingPage) return <LoadingState />

  const canAccess = page?.projectManagement._policies.pagesSeeProjectsRoot.can ?? false
  const hasExpenses = page?.companies.moduleAvailability?.available

  const hasCostsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_costs
  )?.available

  const hasClientsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_clients
  )?.available

  const hasBudgetFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_budget
  )?.available

  const hasPayingProjectsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_overview
  )?.available

  return (
    <AuthorizeUser authorizeFn={() => company && canAccess}>
      <OnboardingContextProvider>
        <Outlet
          context={{
            hasBudgetFeature,
            hasCostsFeature,
            hasExpenses,
            hasClientsFeature,
            hasPayingProjectsFeature,
          }}
        />
      </OnboardingContextProvider>
    </AuthorizeUser>
  )
}

const ProjectsRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default ProjectsRootPage
